import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, ShoppingBag } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center">
      <div className="mx-auto h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center">
        <XCircle className="h-8 w-8 text-slate-500" />
      </div>
      <h1 className="mt-6 font-display font-extrabold text-3xl text-slate-900">Checkout Cancelled</h1>
      <p className="mt-2 text-slate-600">
        No payment was taken. Your cart is still saved — you can complete your order whenever you're ready.
      </p>
      <div className="mt-7 flex justify-center gap-3">
        <Link to="/cart" className="inline-flex items-center gap-2 rounded-xl bg-blue-600 text-white font-semibold px-6 py-3 hover:bg-blue-700 transition-colors">
          <ShoppingBag className="h-4 w-4" /> Return to Cart
        </Link>
        <Link to="/shop" className="inline-flex items-center gap-2 rounded-xl border border-slate-300 text-slate-700 font-semibold px-6 py-3 hover:border-blue-400 hover:text-blue-700 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Keep Shopping
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
